export default __webpack_public_path__ + "static/media/rnr-sports-table-10.a2645fc8.webp";